/** @file The browser's live-sync dependencies: the shared REST client, timers, a WebSocket, the unload guard. */
import { api } from '../api';
import { wsUrl } from '../live/wsUrl';
import type { LiveSyncDeps } from './startLiveSync';

/** Deps for `startLiveSync(projectId, browserSyncDeps(projectId))` in EditorFrame. */
export function browserSyncDeps(projectId: string): LiveSyncDeps {
  return {
    client: api,
    url: wsUrl(projectId, window.location),
    timers: { set: (fn, ms) => window.setTimeout(fn, ms), clear: (id) => { window.clearTimeout(id); } },
    createSocket: (url, on) => {
      const ws = new WebSocket(url);
      ws.onopen = () => { on.open(); };
      ws.onmessage = (event) => { on.message(event.data as unknown); };
      ws.onclose = () => { on.close(); };
      return { send: (data) => { ws.send(data); }, close: () => { ws.close(); } };
    },
    guardUnload: (blocked) => {
      const ask = (event: BeforeUnloadEvent): void => {
        if (blocked()) event.preventDefault();
      };
      window.addEventListener('beforeunload', ask);
      return () => { window.removeEventListener('beforeunload', ask); };
    },
  };
}
